export const freemiumUsecaseList = ["postVisits"];
